import type { CommandEntryName } from "./types";

const COMMAND_ENTRY_NAME_BY_ROUTE = {
  "": "root",
  view: "view",
  start: "start",
  setup: "setup",
  feedback: "feedback",
  repair: "repair.local-state",
  "repair local-state": "repair.local-state",
  uninstall: "uninstall",
  reset: "reset",
  upgrade: "upgrade",
  auth: "auth.menu",
  "auth status": "auth.status",
  "auth login": "auth.login",
  "auth logout": "auth.logout",
  "org list": "organization.list",
  "org current": "organization.current",
  "org switch": "organization.switch",
  "org directory": "organization.directory",
  "org computers": "organization.computers",
  "org invite-link get": "organization.invite_link.get",
  "org invite-link create": "organization.invite_link.create",
  "org invite-link revoke": "organization.invite_link.revoke",
  "center-agent": "center_agent.menu",
  "center-agent ask": "center_agent.ask",
  "center-agent context": "center_agent.context",
  "center-agent status": "center_agent.status",
  "center-agent designate": "center_agent.designate",
  "center-agent pause": "center_agent.pause",
  "center-agent resume": "center_agent.resume",
  "center-agent audit": "center_agent.audit",
  routines: "routines.menu",
  "routines list": "routines.list",
  "routines create": "routines.create",
  "routines show": "routines.show",
  "routines update": "routines.update",
  "routines pause": "routines.pause",
  "routines resume": "routines.resume",
  "routines delete": "routines.delete",
  "routines runs": "routines.runs",
  projects: "projects.menu",
  "projects list": "projects.list",
  "projects create": "projects.create",
  "projects update": "projects.update",
  "projects archive": "projects.archive",
  "projects bind": "projects.bind",
  "projects connections": "projects.connections.menu",
  "projects connections list": "projects.connections.list",
  "projects connections remove": "projects.connections.remove",
  "projects connections set-default": "projects.connections.set-default",
  "projects unbind": "projects.unbind",
  login: "auth.login",
  logout: "auth.logout",
  skills: "skills.menu",
  "plugins list": "plugins.list",
  "plugins actions": "plugins.actions",
  "plugins call": "plugins.call",
  "skills ensure": "skills.ensure",
  "skills install": "skills.install",
  "skills uninstall": "skills.uninstall",
  "skills list": "skills.list",
  "skills ls": "skills.list",
  "skills show": "skills.show",
  "skills load": "skills.load",
  "skills check": "skills.check",
  "skills update": "skills.update",
  "skills upgrade": "skills.update",
  agents: "agents.menu",
  "agents detect": "agents.detect",
  "agents list": "agents.list",
  "agents ls": "agents.list",
  "agents manage": "agents.manage",
  "agents enable": "agents.enable",
  "agents register": "agents.enable",
  "agents repair": "agents.repair",
  "agents disable": "agents.disable",
  "agents unregister": "agents.disable",
  "agents show": "agents.show",
  "agents custom list": "agents.custom.list",
  "agents custom ls": "agents.custom.list",
  "agents custom add": "agents.custom.add",
  "agents custom update": "agents.custom.update",
  "agents custom remove": "agents.custom.remove",
  "agents config": "agents.config",
  "computer list": "computer.list",
  "computer current": "computer.current",
  "computer rename": "computer.rename",
  "computer disconnect": "computer.disconnect",
  service: "service.menu",
  daemon: "service.menu",
  "service run": "service.run",
  "service start": "service.run",
  "daemon run": "service.run",
  "daemon start": "service.run",
  "service status": "service.status",
  "daemon status": "service.status",
  "service snapshot": "service.snapshot",
  "daemon snapshot": "service.snapshot",
  "service interrupt": "service.interrupt",
  "daemon interrupt": "service.interrupt",
  "service cancel": "service.cancel",
  "daemon cancel": "service.cancel",
  "service trace": "service.trace",
  "daemon trace": "service.trace",
  "service install": "service.install",
  "daemon install": "service.install",
  "service autostart enable": "service.autostart",
  "service autostart disable": "service.autostart",
  "service uninstall": "service.uninstall",
  "daemon uninstall": "service.uninstall",
  "service reinstall": "service.reinstall",
  "service repair": "service.reinstall",
  "service update": "service.reinstall",
  "daemon reinstall": "service.reinstall",
  "daemon repair": "service.reinstall",
  "daemon update": "service.reinstall",
  "service stop": "service.stop",
  "daemon stop": "service.stop",
  space: "space.menu",
  spaces: "space.menu",
  "space create": "space.create",
  "spaces create": "space.create",
  "space delete": "space.delete",
  "spaces delete": "space.delete",
  "space join": "space.join",
  "spaces join": "space.join",
  "space add-me": "space.add-me",
  "spaces add-me": "space.add-me",
  "space add-members": "space.add-members",
  "spaces add-members": "space.add-members",
  "space add-agents": "space.add-agents",
  "spaces add-agents": "space.add-agents",
  "space add-human-profiles": "space.add-human-profiles",
  "spaces add-human-profiles": "space.add-human-profiles",
  "space add-profiles": "space.add-members",
  "spaces add-profiles": "space.add-members",
  "space remove-members": "space.remove-members",
  "spaces remove-members": "space.remove-members",
  "space leave": "space.leave",
  "spaces leave": "space.leave",
  "space files handoff": "space.files.handoff",
  "spaces files handoff": "space.files.handoff",
  "space files working-copy": "space.files.working-copy",
  "spaces files working-copy": "space.files.working-copy",
  "space files list": "space.files.list",
  "spaces files list": "space.files.list",
  "space files read": "space.files.read",
  "spaces files read": "space.files.read",
  "space files upload": "space.files.upload",
  "spaces files upload": "space.files.upload",
  "space files write": "space.files.write",
  "spaces files write": "space.files.write",
  "space files download": "space.files.download",
  "spaces files download": "space.files.download",
  "space files mkdir": "space.files.mkdir",
  "spaces files mkdir": "space.files.mkdir",
  "space files rename": "space.files.rename",
  "spaces files rename": "space.files.rename",
  "space files move": "space.files.move",
  "spaces files move": "space.files.move",
  "space files trash": "space.files.trash",
  "spaces files trash": "space.files.trash",
  "space files history": "space.files.history",
  "spaces files history": "space.files.history",
  "space files restore": "space.files.restore",
  "spaces files restore": "space.files.restore",
  "space files restore-version": "space.files.restore-version",
  "spaces files restore-version": "space.files.restore-version",
  "space watch": "space.watch",
  "spaces watch": "space.watch",
  "space send": "space.send",
  "spaces send": "space.send",
  send: "space.send",
  "space history": "space.history",
  "spaces history": "space.history",
  "space thread": "space.thread",
  "spaces thread": "space.thread",
  "space board": "space.board",
  "spaces board": "space.board",
  "space members": "space.members",
  "spaces members": "space.members",
  "space contract": "space.contract",
  "spaces contract": "space.contract",
  "space contract set": "space.contract.set",
  "spaces contract set": "space.contract.set",
  "space publication set": "space.publication.set",
  "spaces publication set": "space.publication.set",
  "space access": "space.access",
  "spaces access": "space.access",
  "space status": "space.status",
  "spaces status": "space.status",
  "space updates": "space.updates",
  "spaces updates": "space.updates",
  "space result": "space.result",
  "spaces result": "space.result",
  "space wake-progress": "space.wake_progress",
  "spaces wake-progress": "space.wake_progress",
  "space wake-stop": "space.wake_stop",
  "spaces wake-stop": "space.wake_stop",
  tail: "space.history",
  "space list": "space.list",
  "spaces list": "space.list",
  "space ls": "space.list",
  "spaces ls": "space.list",
  "space list --organization": "space.list.organization",
  "spaces list --organization": "space.list.organization",
  "space join --self-serve": "space.join.self_serve",
  "spaces join --self-serve": "space.join.self_serve",
  "space password": "space.password",
  "spaces password": "space.password",
  "space guide": "space.guide",
  "spaces guide": "space.guide",
  "space guide set": "space.guide.set",
  "spaces guide set": "space.guide.set",
  "space guide clear": "space.guide.clear",
  "spaces guide clear": "space.guide.clear",
  doctor: "doctor",
  whoami: "whoami",
  profiles: "profile.menu",
  profile: "profile.menu",
  "profiles create": "profile.create",
  "profile create": "profile.create",
  "profiles current-session": "profile.current-session",
  "profile current-session": "profile.current-session",
  "profiles list": "profile.list",
  "profiles ls": "profile.list",
  "profile list": "profile.list",
  "profile ls": "profile.list",
  "profiles set": "profile.set",
  "profile set": "profile.set",
  "profiles show": "profile.show",
  "profile show": "profile.show",
  "profiles update": "profile.update",
  "profile update": "profile.update",
  "profile execution-mode": "profile.execution-mode",
  "profiles execution-mode": "profile.execution-mode",
  "profiles delete": "profile.delete",
  "profile delete": "profile.delete",
  "profile requests create": "profile.requests.create",
  "profile requests list": "profile.requests.list",
  "profile requests approve": "profile.requests.approve",
  "profile requests decline": "profile.requests.decline",
  "profile requests cancel": "profile.requests.cancel",
  "profile requests retry": "profile.requests.retry",
  "profile requests preferences get": "profile.requests.preferences.get",
  "profile requests preferences set": "profile.requests.preferences.set",
} as const satisfies Record<string, CommandEntryName>;

export const COMMAND_ENTRY_ROUTE_KEYS = Object.freeze(
  Object.keys(COMMAND_ENTRY_NAME_BY_ROUTE).sort((left, right) =>
    left.localeCompare(right)
  )
);

export function resolveCommandEntryNameFromRoute(
  route: string
): CommandEntryName | null {
  return (
    COMMAND_ENTRY_NAME_BY_ROUTE[
      route as keyof typeof COMMAND_ENTRY_NAME_BY_ROUTE
    ] ?? null
  );
}

export function resolveCommandEntryNameFromTokens(
  tokens: string[]
): CommandEntryName | null {
  const normalized = tokens
    .map((token) => token.trim())
    .filter((token) => token.length > 0)
    .join(" ");
  if (normalized.length === 0) {
    return resolveCommandEntryNameFromRoute("");
  }
  return resolveCommandEntryNameFromRoute(normalized);
}
